import React, { useState, useEffect } from 'react'
import { X, Download } from 'lucide-react'
import ModalTest from '../../../../components/BaseModal'
import { PDFDownloadLink } from '@react-pdf/renderer'
import BodyOfPDFFashion from '../../../../components/PDF/Fashion/Body'
import type { FashionOpPdfData } from '../../../../components/PDF/Fashion/fashionOpPdfTypes'
import { ContainerOfModal, Header, HeaderTitle, CloseDiv, Button } from '../../../../components/styles/modal-style'
import { FashionProductionOrderData } from '../FashionPcp'
import QRCode from 'qrcode'
import FashionApiService from '../../../../services/FashionApiService'

interface GeneratePDFModalFashionProps {
  onClickClose: () => void
  productionOrder: FashionProductionOrderData | null
}

const GeneratePDFModalFashion: React.FC<GeneratePDFModalFashionProps> = ({ onClickClose, productionOrder }) => {
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState<string>('')
  const [pdfData, setPdfData] = useState<FashionOpPdfData | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchPdfData = async () => {
      if (!productionOrder?.id) return

      try {
        setIsLoading(true)
        const response = await FashionApiService.getProductionOrderPdfData(productionOrder.id)
        setPdfData(response.data)
      } catch (error) {
        console.error('Erro ao buscar dados do PDF da ordem de produção:', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchPdfData()
  }, [productionOrder?.id])

  useEffect(() => {
    const generateQRCode = async () => {
      if (!pdfData?.id) return

      try {
        const qrCodeUrl = await QRCode.toDataURL(pdfData.id.toString(), {
          width: 200,
          margin: 1,
          color: {
            dark: '#000000',
            light: '#FFFFFF',
          },
        })
        setQrCodeDataUrl(qrCodeUrl)
      } catch (error) {
        console.error('Erro ao gerar QR code:', error)
      }
    }

    generateQRCode()
  }, [pdfData?.id])

  return (
    <ModalTest>
      <ContainerOfModal width='500px'>
        <Header>
          <HeaderTitle>Gerar PDF</HeaderTitle>
          <CloseDiv onClick={onClickClose}>
            <X size={20} />
          </CloseDiv>
        </Header>

        <div>
          <p style={{ marginBottom: '2rem', fontSize: '16px', color: '#666' }}>
            Clique no botão abaixo para baixar o PDF da OP
          </p>

          <PDFDownloadLink
            document={<BodyOfPDFFashion data={pdfData} qrCodeDataUrl={qrCodeDataUrl} />}
            fileName={`OP-${pdfData?.id || productionOrder?.id || 'documento'}.pdf`}
          >
            {({ loading }) => (
              <Button disabled={loading || isLoading || !pdfData || !qrCodeDataUrl}>
                <Download size={16} />
                {loading || isLoading ? 'Preparando...' : 'Baixar PDF'}
              </Button>
            )}
          </PDFDownloadLink>
        </div>
      </ContainerOfModal>
    </ModalTest>
  )
}

export default GeneratePDFModalFashion
